/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './hosting-service-schema-types';

import { ResourceStatus } from '../modules/stations/HostingService/common/ExtendedGraphQLTypes';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './hosting-service-schema-types';
const defaultOptions = {} as const;
export type StorageAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type StorageAccountQuery = { objectStorages: { nodes: Array<{ id: any, title: string, name: string | null, azureConnectionString: string | null, azureStorageAccountKey: string | null, tenantId: any, environmentId: any, provider: Types.ProviderType, status: Types.ResourceStatus, errorMessage: string | null, createdDate: any, createdUser: string, updatedDate: any, updatedUser: string }> } | null };

export type ObjectStorageDetailsQueryVariables = Exact<{
  input: Types.ObjectStorageDetailsQueryInput;
}>;


export type ObjectStorageDetailsQuery = { objectStorageDetails: { containerCount: number | null, storageAccountConsumptionInBytes: number | null } | null };

export type RegenerateObjectStorageConnectionStringMutationVariables = Exact<{
  input: Types.RegenerateObjectStorageConnectionStringInput;
}>;


export type RegenerateObjectStorageConnectionStringMutation = { regenerateObjectStorageConnectionString: { storageAccountConnectionString: string } | null };

export type CreateAzureStorageContainerMutationVariables = Exact<{
  input: Types.CreateAzureStorageContainerInput;
}>;


export type CreateAzureStorageContainerMutation = { createAzureStorageContainer: { container: { hasPublicReadAccess: boolean | null, name: string, publicUrl: string | null, updatedAt: string } | null } | null };

export type AzureStorageAccountContainerQueryVariables = Exact<{
  input: Types.AzureStorageContainerQueryInput;
}>;


export type AzureStorageAccountContainerQuery = { azureStorageContainer: { tenantId: any, container: { hasPublicReadAccess: boolean | null, name: string, publicUrl: string | null, updatedAt: string } | null } | null };

export type UpdateAzureStorageContainerMutationVariables = Exact<{
  input: Types.UpdateAzureStorageContainerInput;
}>;


export type UpdateAzureStorageContainerMutation = { updateAzureStorageContainer: { success: boolean, error: string | null, container: { updatedAt: string, publicUrl: string | null, name: string, hasPublicReadAccess: boolean | null } | null } | null };

export type DeleteAzureStorageContainerMutationVariables = Exact<{
  input: Types.DeleteAzureStorageContainerInput;
}>;


export type DeleteAzureStorageContainerMutation = { deleteAzureStorageContainer: { container: { name: string } | null } | null };

export type ContainerRegistryConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContainerRegistryConnectionsQuery = { containerRegistryConnections: { nodes: Array<{ createdDate: any, createdUser: string, environmentId: any, host: string, id: any, password: string | null, tenantId: any, username: string | null, updatedUser: string, updatedDate: any }> } | null };

export type CreateContainerRegistryConnectionMutationVariables = Exact<{
  input: Types.CreateContainerRegistryConnectionInput;
}>;


export type CreateContainerRegistryConnectionMutation = { createContainerRegistryConnection: { clientMutationId: string | null } | null };

export type UpdateContainerRegistryConnectionMutationVariables = Exact<{
  input: Types.UpdateContainerRegistryConnectionInput;
}>;


export type UpdateContainerRegistryConnectionMutation = { updateContainerRegistryConnection: { clientMutationId: string | null } | null };

export type DeleteContainerRegistryConnectionMutationVariables = Exact<{
  input: Types.DeleteContainerRegistryConnectionInput;
}>;


export type DeleteContainerRegistryConnectionMutation = { deleteContainerRegistryConnection: { clientMutationId: string | null } | null };

export type ContainerImagesQueryVariables = Exact<{
  id: any;
}>;


export type ContainerImagesQuery = { serviceDefinition: { id: any, repositoryTags: Array<{ containerImageVersion: string, tag: string }>, serviceDeployments: { nodes: Array<{ containerImageVersion: string }> } } | null };

export type AzureStorageContainerSasTokenParamsQueryVariables = Exact<{
  input: Types.AzureStorageContainerSasTokenParamsInput;
}>;


export type AzureStorageContainerSasTokenParamsQuery = { azureStorageContainerSASTokenParams: { allowedIPs: string | null, allowedProtocols: string | null, permissions: Array<string | null> | null, validFrom: string | null, validUntil: string | null } | null };

export type GenerateAzureStorageContainerSasTokenMutationVariables = Exact<{
  input: Types.GenerateAzureStorageContainerSasTokenInput;
}>;


export type GenerateAzureStorageContainerSasTokenMutation = { generateAzureStorageContainerSASToken: { sasTokenUri: string, sasTokenParams: string } | null };

export type AzureStorageAccountContainersQueryVariables = Exact<{
  input: Types.AzureStorageContainersQueryInput;
}>;


export type AzureStorageAccountContainersQuery = { azureStorageContainers: { containers: Array<{ hasPublicReadAccess: boolean | null, name: string, publicUrl: string | null, updatedAt: string } | null> | null } | null };

export type UpdateDeploymentServiceMutationVariables = Exact<{
  input: Types.UpdateServiceDeploymentInput;
}>;


export type UpdateDeploymentServiceMutation = { updateServiceDeployment: { clientMutationId: string | null } | null };

export type ServiceDeploymentDetailsQueryVariables = Exact<{
  id: any;
}>;


export type ServiceDeploymentDetailsQuery = { serviceDeployment: { containerImageVersion: string, servicePiletArtifacts: string | null, status: Types.ResourceStatus, serviceDefinitionId: any, name: string, createdDate: any, createdUser: string, active: boolean, updatedDate: any, updatedUser: string, tenantId: any, id: any, errorMessage: string | null, dnsRecords: { nodes: Array<{ fqdn: string, configRefName: string }> }, serviceDeploymentManifest: { id: any, name: string, createdDate: any } | null, serviceDefinition: { repositoryName: string, serviceId: string, name: string, ownedByAxinom: boolean, servicePiletArtifacts: { nodes: Array<{ packageVersion: string, name: string, id: any }> } } | null } | null };

export type CustomizableServiceDeploymentsQueryVariables = Exact<{
  filter?: Types.ServiceDeploymentFilter | null | undefined;
  condition?: Types.ServiceDeploymentCondition | null | undefined;
  orderBy?: Array<Types.ServiceDeploymentsOrderBy> | Types.ServiceDeploymentsOrderBy | null | undefined;
  after?: any;
}>;


export type CustomizableServiceDeploymentsQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ active: boolean, containerImageVersion: string, status: Types.ResourceStatus, servicePiletArtifacts: string | null, createdDate: any, updatedDate: any, id: any, name: string, serviceDefinitionId: any, serviceDeploymentManifest: { name: string } | null, serviceDefinition: { name: string, id: any, repositoryName: string } | null }> } | null, nonFiltered: { totalCount: number } | null };

export type CreateServiceDeploymentMutationVariables = Exact<{
  input: Types.InitiateServiceDeploymentInput;
}>;


export type CreateServiceDeploymentMutation = { initiateServiceDeployment: { serviceDefinitionId: any, serviceDeploymentId: any, status: Types.ResourceStatus, name: string } };

export type UnDeploymentServiceMutationVariables = Exact<{
  input: Types.InitiateServiceUndeploymentInput;
}>;


export type UnDeploymentServiceMutation = { initiateServiceUndeployment: { serviceDefinitionId: any, serviceDeploymentId: any, status: Types.ResourceStatus } };

export type ReDeploymentServiceMutationVariables = Exact<{
  input: Types.InitiateServiceRedeploymentInput;
}>;


export type ReDeploymentServiceMutation = { initiateServiceRedeployment: { serviceDefinitionId: any, serviceDeploymentId: any, status: Types.ResourceStatus } };

export type ServicePiletArtifactsQueryVariables = Exact<{
  condition?: Types.ServicePiletArtifactCondition | null | undefined;
  filter?: Types.ServicePiletArtifactFilter | null | undefined;
  orderBy?: Array<Types.ServicePiletArtifactsOrderBy> | Types.ServicePiletArtifactsOrderBy | null | undefined;
  after?: any;
}>;


export type ServicePiletArtifactsQuery = { filtered: { totalCount: number, nodes: Array<{ id: any, name: string, packageVersion: string }>, pageInfo: { endCursor: any, hasNextPage: boolean } } | null, nonFiltered: { totalCount: number } | null };

export type ServiceDeploymentManifestsQueryVariables = Exact<{
  condition?: Types.ServiceDeploymentManifestCondition | null | undefined;
  filter?: Types.ServiceDeploymentManifestFilter | null | undefined;
  orderBy?: Array<Types.ServiceDeploymentManifestsOrderBy> | Types.ServiceDeploymentManifestsOrderBy | null | undefined;
  after?: any;
}>;


export type ServiceDeploymentManifestsQuery = { filtered: { totalCount: number, nodes: Array<{ id: any, createdDate: any, name: string, currentlyInUse: boolean | null }>, pageInfo: { endCursor: any, hasNextPage: boolean } } | null, nonFiltered: { totalCount: number } | null };

export type CustomizableServiceQueryVariables = Exact<{
  id: any;
}>;


export type CustomizableServiceQuery = { serviceDefinition: { id: any, tenantId: any, environmentId: any, updatedUser: string, updatedDate: any, createdUser: string, createdDate: any, name: string, repositoryName: string, ownedByAxinom: boolean, evaluationPodExpirationDate: any, serviceId: string, customDnsServiceLabel: string | null, databaseAccessExpiresAt: any, serviceDeploymentManifest: { nodes: Array<{ id: any, configMap: any, createdDate: any, name: string }> }, servicePiletArtifacts: { nodes: Array<{ id: any, name: string, packageVersion: string }> }, serviceDeployments: { nodes: Array<{ name: string, servicePiletArtifacts: string | null, id: any, status: Types.ResourceStatus, errorMessage: string | null, updatedUser: string, updatedDate: any, createdUser: string, createdDate: any, containerImageVersion: string, servicePiletArtifactIds: Array<any>, serviceDefinition: { ownedByAxinom: boolean } | null, serviceDeploymentManifest: { id: any, createdDate: any, name: string } | null, dnsRecords: { nodes: Array<{ fqdn: string, configRefName: string }> } }> } } | null };

export type RepositoryTagsQueryVariables = Exact<{
  id: any;
}>;


export type RepositoryTagsQuery = { serviceDefinition: { repositoryTags: Array<{ tag: string }> } | null };

export type CustomizableServiceCrumbDataQueryVariables = Exact<{
  id: any;
}>;


export type CustomizableServiceCrumbDataQuery = { serviceDefinition: { name: string } | null };

export type DeployServiceMutationVariables = Exact<{
  input: Types.InitiateServiceDeploymentInput;
}>;


export type DeployServiceMutation = { initiateServiceDeployment: { serviceDefinitionId: any } };

export type UndeployServiceMutationVariables = Exact<{
  input: Types.InitiateServiceUndeploymentInput;
}>;


export type UndeployServiceMutation = { initiateServiceUndeployment: { serviceDeploymentId: any } };

export type UpdateServiceDefinitionMutationVariables = Exact<{
  input: Types.UpdateServiceDefinitionInput;
}>;


export type UpdateServiceDefinitionMutation = { updateServiceDefinition: { clientMutationId: string | null, serviceDefinition: { id: any, name: string, customDnsServiceLabel: string | null } | null } | null };

export type DeleteServiceDefinitionMutationVariables = Exact<{
  input: Types.DeleteServiceDefinitionInput;
}>;


export type DeleteServiceDefinitionMutation = { deleteServiceDefinition: { clientMutationId: string | null } | null };

export type SetServiceExpirationDateMutationVariables = Exact<{
  input: Types.SetServiceExpirationDateInput;
}>;


export type SetServiceExpirationDateMutation = { setServiceExpirationDate: { serviceDefinitionId: any, expirationDate: any } };

export type SetDatabaseAccessMutationVariables = Exact<{
  input: Types.SetDatabaseAccessInput;
}>;


export type SetDatabaseAccessMutation = { setDatabaseAccess: { serviceDefinitionId: any, databaseAccessExpiresAt: any } };

export type PiletArtifactsQueryVariables = Exact<{
  id: any;
}>;


export type PiletArtifactsQuery = { serviceDefinition: { servicePiletArtifacts: { nodes: Array<{ packageVersion: string, name: string, id: any }> }, serviceDeployments: { nodes: Array<{ servicePiletArtifactIds: Array<any> }> } } | null };

export type CustomizableServicesQueryVariables = Exact<{
  filter?: Types.ServiceDefinitionFilter | null | undefined;
  orderBy?: Array<Types.ServiceDefinitionsOrderBy> | Types.ServiceDefinitionsOrderBy | null | undefined;
  after?: any;
}>;


export type CustomizableServicesQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, serviceId: string, name: string, ownedByAxinom: boolean, activeDeploymentStatus: string | null, evaluationPodExpirationDate: any }> } | null, nonFiltered: { totalCount: number } | null };

export type CreateServiceDefinitionMutationVariables = Exact<{
  input: Types.CreateServiceDefinitionInput;
}>;


export type CreateServiceDefinitionMutation = { createServiceDefinition: { clientMutationId: string | null, serviceDefinition: { name: string, id: any } | null } | null };

export type DeploymentManifestQueryVariables = Exact<{
  id: any;
}>;


export type DeploymentManifestQuery = { serviceDeploymentManifest: { id: any, name: string, serviceId: string | null, serviceDefinitionId: any, ownedByAxinom: boolean, createdDate: any, createdUser: string, configMap: any, tenantId: any, environmentId: any, serviceDefinition: { id: any, name: string } | null } | null };

export type UpdateDeploymentManifestMutationVariables = Exact<{
  input: Types.UpdateServiceDeploymentManifestInput;
}>;


export type UpdateDeploymentManifestMutation = { updateServiceDeploymentManifest: { clientMutationId: string | null } | null };

export type DeploymentManifestsQueryVariables = Exact<{
  condition?: Types.ServiceDeploymentManifestCondition | null | undefined;
  filter?: Types.ServiceDeploymentManifestFilter | null | undefined;
  orderBy?: Array<Types.ServiceDeploymentManifestsOrderBy> | Types.ServiceDeploymentManifestsOrderBy | null | undefined;
  after?: any;
}>;


export type DeploymentManifestsQuery = { filtered: { totalCount: number, pageInfo: { hasNextPage: boolean, endCursor: any }, nodes: Array<{ id: any, name: string, createdDate: any, currentlyInUse: boolean | null }> } | null, nonFiltered: { totalCount: number } | null };

export type DeleteDeploymentManifestMutationVariables = Exact<{
  input: Types.DeleteServiceDeploymentManifestInput;
}>;


export type DeleteDeploymentManifestMutation = { deleteServiceDeploymentManifest: { clientMutationId: string | null } | null };

export type HostingServiceConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type HostingServiceConfigurationsQuery = { serviceConfigurations: { nodes: Array<{ id: any, tenantId: any, environmentId: any, updatedDate: any, updatedUser: string }> } | null };

export type HostingServiceStorageQueryVariables = Exact<{ [key: string]: never; }>;


export type HostingServiceStorageQuery = { objectStorages: { nodes: Array<{ id: any, title: string, tenantId: any, environmentId: any, provider: Types.ProviderType, status: Types.ResourceStatus, createdDate: any, createdUser: string, updatedDate: any, updatedUser: string }> } | null };

export type EnableStorageMutationVariables = Exact<{
  input: Types.EnableStorageInput;
}>;


export type EnableStorageMutation = { enableStorage: { success: boolean } | null };

export type DisableStorageMutationVariables = Exact<{
  input: Types.DisableStorageInput;
}>;


export type DisableStorageMutation = { disableStorage: { success: boolean } | null };

export type ReadyServiceDeploymentsQueryVariables = Exact<{
  filter?: Types.ServiceDeploymentFilter | null | undefined;
}>;


export type ReadyServiceDeploymentsQuery = { serviceDeployments: { totalCount: number } | null };

export type RmqConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type RmqConnectionQuery = { rmqConnection: { tenantId: string, environmentId: string, rmqProtocol: string, rmqHost: string, rmqPort: string, rmqMgmtProtocol: string, rmqMgmtHost: string, rmqMgmtPort: string, rmqVHost: string | null, rmqUser: string | null, rmqPassword: string | null } | null };

export type DeleteCredentialsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCredentialsMutation = { deleteRMQUser: { environmentId: string, rmqUser: string, rmqVHost: string, tenantId: string } | null };

export type SetupRmqUserMutationVariables = Exact<{ [key: string]: never; }>;


export type SetupRmqUserMutation = { setupRMQUser: { tenantId: string, environmentId: string, rmqProtocol: string, rmqHost: string, rmqPort: string, rmqMgmtProtocol: string, rmqMgmtHost: string, rmqMgmtPort: string, rmqVHost: string, rmqUser: string, rmqPassword: string } | null };

export type ServiceDeploymentLogsQueryVariables = Exact<{
  condition?: Types.ServiceDeploymentLogCondition | null | undefined;
  orderBy?: Array<Types.ServiceDeploymentLogsOrderBy> | Types.ServiceDeploymentLogsOrderBy | null | undefined;
}>;


export type ServiceDeploymentLogsQuery = { serviceDeploymentLogs: { nodes: Array<{ id: any, initiatedBy: string, messageType: string, message: any, serviceDefinitionId: any, timestamp: any }> } | null };

export type ObjectStorageLogsQueryVariables = Exact<{
  condition?: Types.ObjectStorageLogCondition | null | undefined;
  orderBy?: Array<Types.ObjectStorageLogsOrderBy> | Types.ObjectStorageLogsOrderBy | null | undefined;
}>;


export type ObjectStorageLogsQuery = { objectStorageLogs: { nodes: Array<{ id: any, environmentId: any, message: any, messageType: string, tenantId: any, timestamp: any }> } | null };


export const StorageAccountDocument = gql`
    query StorageAccount {
  objectStorages(first: 1, offset: 0) {
    nodes {
      id
      title
      name
      azureConnectionString
      azureStorageAccountKey
      tenantId
      environmentId
      provider
      status
      errorMessage
      createdDate
      createdUser
      updatedDate
      updatedUser
    }
  }
}
    `;

/**
 * __useStorageAccountQuery__
 *
 * To run a query within a React component, call `useStorageAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useStorageAccountQuery(baseOptions?: Apollo.QueryHookOptions<StorageAccountQuery, StorageAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorageAccountQuery, StorageAccountQueryVariables>(StorageAccountDocument, options);
      }
export function useStorageAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorageAccountQuery, StorageAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorageAccountQuery, StorageAccountQueryVariables>(StorageAccountDocument, options);
        }
export type StorageAccountQueryHookResult = ReturnType<typeof useStorageAccountQuery>;
export type StorageAccountLazyQueryHookResult = ReturnType<typeof useStorageAccountLazyQuery>;
export type StorageAccountQueryResult = Apollo.QueryResult<StorageAccountQuery, StorageAccountQueryVariables>;
export const ObjectStorageDetailsDocument = gql`
    query ObjectStorageDetails($input: ObjectStorageDetailsQueryInput!) {
  objectStorageDetails(input: $input) {
    containerCount
    storageAccountConsumptionInBytes
  }
}
    `;

/**
 * __useObjectStorageDetailsQuery__
 *
 * To run a query within a React component, call `useObjectStorageDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectStorageDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectStorageDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useObjectStorageDetailsQuery(baseOptions: Apollo.QueryHookOptions<ObjectStorageDetailsQuery, ObjectStorageDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectStorageDetailsQuery, ObjectStorageDetailsQueryVariables>(ObjectStorageDetailsDocument, options);
      }
export function useObjectStorageDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectStorageDetailsQuery, ObjectStorageDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectStorageDetailsQuery, ObjectStorageDetailsQueryVariables>(ObjectStorageDetailsDocument, options);
        }
export type ObjectStorageDetailsQueryHookResult = ReturnType<typeof useObjectStorageDetailsQuery>;
export type ObjectStorageDetailsLazyQueryHookResult = ReturnType<typeof useObjectStorageDetailsLazyQuery>;
export type ObjectStorageDetailsQueryResult = Apollo.QueryResult<ObjectStorageDetailsQuery, ObjectStorageDetailsQueryVariables>;
export const RegenerateObjectStorageConnectionStringDocument = gql`
    mutation RegenerateObjectStorageConnectionString($input: RegenerateObjectStorageConnectionStringInput!) {
  regenerateObjectStorageConnectionString(input: $input) {
    storageAccountConnectionString
  }
}
    `;
export type RegenerateObjectStorageConnectionStringMutationFn = Apollo.MutationFunction<RegenerateObjectStorageConnectionStringMutation, RegenerateObjectStorageConnectionStringMutationVariables>;

/**
 * __useRegenerateObjectStorageConnectionStringMutation__
 *
 * To run a mutation, you first call `useRegenerateObjectStorageConnectionStringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateObjectStorageConnectionStringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateObjectStorageConnectionStringMutation, { data, loading, error }] = useRegenerateObjectStorageConnectionStringMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateObjectStorageConnectionStringMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateObjectStorageConnectionStringMutation, RegenerateObjectStorageConnectionStringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateObjectStorageConnectionStringMutation, RegenerateObjectStorageConnectionStringMutationVariables>(RegenerateObjectStorageConnectionStringDocument, options);
      }
export type RegenerateObjectStorageConnectionStringMutationHookResult = ReturnType<typeof useRegenerateObjectStorageConnectionStringMutation>;
export type RegenerateObjectStorageConnectionStringMutationResult = Apollo.MutationResult<RegenerateObjectStorageConnectionStringMutation>;
export type RegenerateObjectStorageConnectionStringMutationOptions = Apollo.BaseMutationOptions<RegenerateObjectStorageConnectionStringMutation, RegenerateObjectStorageConnectionStringMutationVariables>;
export const CreateAzureStorageContainerDocument = gql`
    mutation CreateAzureStorageContainer($input: CreateAzureStorageContainerInput!) {
  createAzureStorageContainer(input: $input) {
    container {
      hasPublicReadAccess
      name
      publicUrl
      updatedAt
    }
  }
}
    `;
export type CreateAzureStorageContainerMutationFn = Apollo.MutationFunction<CreateAzureStorageContainerMutation, CreateAzureStorageContainerMutationVariables>;

/**
 * __useCreateAzureStorageContainerMutation__
 *
 * To run a mutation, you first call `useCreateAzureStorageContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAzureStorageContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAzureStorageContainerMutation, { data, loading, error }] = useCreateAzureStorageContainerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAzureStorageContainerMutation(baseOptions?: Apollo.MutationHookOptions<CreateAzureStorageContainerMutation, CreateAzureStorageContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAzureStorageContainerMutation, CreateAzureStorageContainerMutationVariables>(CreateAzureStorageContainerDocument, options);
      }
export type CreateAzureStorageContainerMutationHookResult = ReturnType<typeof useCreateAzureStorageContainerMutation>;
export type CreateAzureStorageContainerMutationResult = Apollo.MutationResult<CreateAzureStorageContainerMutation>;
export type CreateAzureStorageContainerMutationOptions = Apollo.BaseMutationOptions<CreateAzureStorageContainerMutation, CreateAzureStorageContainerMutationVariables>;
export const AzureStorageAccountContainerDocument = gql`
    query AzureStorageAccountContainer($input: AzureStorageContainerQueryInput!) {
  azureStorageContainer(input: $input) {
    container {
      hasPublicReadAccess
      name
      publicUrl
      updatedAt
    }
    tenantId
  }
}
    `;

/**
 * __useAzureStorageAccountContainerQuery__
 *
 * To run a query within a React component, call `useAzureStorageAccountContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureStorageAccountContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureStorageAccountContainerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAzureStorageAccountContainerQuery(baseOptions: Apollo.QueryHookOptions<AzureStorageAccountContainerQuery, AzureStorageAccountContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureStorageAccountContainerQuery, AzureStorageAccountContainerQueryVariables>(AzureStorageAccountContainerDocument, options);
      }
export function useAzureStorageAccountContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureStorageAccountContainerQuery, AzureStorageAccountContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureStorageAccountContainerQuery, AzureStorageAccountContainerQueryVariables>(AzureStorageAccountContainerDocument, options);
        }
export type AzureStorageAccountContainerQueryHookResult = ReturnType<typeof useAzureStorageAccountContainerQuery>;
export type AzureStorageAccountContainerLazyQueryHookResult = ReturnType<typeof useAzureStorageAccountContainerLazyQuery>;
export type AzureStorageAccountContainerQueryResult = Apollo.QueryResult<AzureStorageAccountContainerQuery, AzureStorageAccountContainerQueryVariables>;
export const UpdateAzureStorageContainerDocument = gql`
    mutation UpdateAzureStorageContainer($input: UpdateAzureStorageContainerInput!) {
  updateAzureStorageContainer(input: $input) {
    success
    error
    container {
      updatedAt
      publicUrl
      name
      hasPublicReadAccess
    }
  }
}
    `;
export type UpdateAzureStorageContainerMutationFn = Apollo.MutationFunction<UpdateAzureStorageContainerMutation, UpdateAzureStorageContainerMutationVariables>;

/**
 * __useUpdateAzureStorageContainerMutation__
 *
 * To run a mutation, you first call `useUpdateAzureStorageContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAzureStorageContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAzureStorageContainerMutation, { data, loading, error }] = useUpdateAzureStorageContainerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAzureStorageContainerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAzureStorageContainerMutation, UpdateAzureStorageContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAzureStorageContainerMutation, UpdateAzureStorageContainerMutationVariables>(UpdateAzureStorageContainerDocument, options);
      }
export type UpdateAzureStorageContainerMutationHookResult = ReturnType<typeof useUpdateAzureStorageContainerMutation>;
export type UpdateAzureStorageContainerMutationResult = Apollo.MutationResult<UpdateAzureStorageContainerMutation>;
export type UpdateAzureStorageContainerMutationOptions = Apollo.BaseMutationOptions<UpdateAzureStorageContainerMutation, UpdateAzureStorageContainerMutationVariables>;
export const DeleteAzureStorageContainerDocument = gql`
    mutation DeleteAzureStorageContainer($input: DeleteAzureStorageContainerInput!) {
  deleteAzureStorageContainer(input: $input) {
    container {
      name
    }
  }
}
    `;
export type DeleteAzureStorageContainerMutationFn = Apollo.MutationFunction<DeleteAzureStorageContainerMutation, DeleteAzureStorageContainerMutationVariables>;

/**
 * __useDeleteAzureStorageContainerMutation__
 *
 * To run a mutation, you first call `useDeleteAzureStorageContainerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAzureStorageContainerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAzureStorageContainerMutation, { data, loading, error }] = useDeleteAzureStorageContainerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAzureStorageContainerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAzureStorageContainerMutation, DeleteAzureStorageContainerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAzureStorageContainerMutation, DeleteAzureStorageContainerMutationVariables>(DeleteAzureStorageContainerDocument, options);
      }
export type DeleteAzureStorageContainerMutationHookResult = ReturnType<typeof useDeleteAzureStorageContainerMutation>;
export type DeleteAzureStorageContainerMutationResult = Apollo.MutationResult<DeleteAzureStorageContainerMutation>;
export type DeleteAzureStorageContainerMutationOptions = Apollo.BaseMutationOptions<DeleteAzureStorageContainerMutation, DeleteAzureStorageContainerMutationVariables>;
export const ContainerRegistryConnectionsDocument = gql`
    query ContainerRegistryConnections {
  containerRegistryConnections {
    nodes {
      createdDate
      createdUser
      environmentId
      host
      id
      password
      tenantId
      username
      updatedUser
      updatedDate
    }
  }
}
    `;

/**
 * __useContainerRegistryConnectionsQuery__
 *
 * To run a query within a React component, call `useContainerRegistryConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerRegistryConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerRegistryConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useContainerRegistryConnectionsQuery(baseOptions?: Apollo.QueryHookOptions<ContainerRegistryConnectionsQuery, ContainerRegistryConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContainerRegistryConnectionsQuery, ContainerRegistryConnectionsQueryVariables>(ContainerRegistryConnectionsDocument, options);
      }
export function useContainerRegistryConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContainerRegistryConnectionsQuery, ContainerRegistryConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContainerRegistryConnectionsQuery, ContainerRegistryConnectionsQueryVariables>(ContainerRegistryConnectionsDocument, options);
        }
export type ContainerRegistryConnectionsQueryHookResult = ReturnType<typeof useContainerRegistryConnectionsQuery>;
export type ContainerRegistryConnectionsLazyQueryHookResult = ReturnType<typeof useContainerRegistryConnectionsLazyQuery>;
export type ContainerRegistryConnectionsQueryResult = Apollo.QueryResult<ContainerRegistryConnectionsQuery, ContainerRegistryConnectionsQueryVariables>;
export const CreateContainerRegistryConnectionDocument = gql`
    mutation CreateContainerRegistryConnection($input: CreateContainerRegistryConnectionInput!) {
  createContainerRegistryConnection(input: $input) {
    clientMutationId
  }
}
    `;
export type CreateContainerRegistryConnectionMutationFn = Apollo.MutationFunction<CreateContainerRegistryConnectionMutation, CreateContainerRegistryConnectionMutationVariables>;

/**
 * __useCreateContainerRegistryConnectionMutation__
 *
 * To run a mutation, you first call `useCreateContainerRegistryConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContainerRegistryConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContainerRegistryConnectionMutation, { data, loading, error }] = useCreateContainerRegistryConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContainerRegistryConnectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateContainerRegistryConnectionMutation, CreateContainerRegistryConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContainerRegistryConnectionMutation, CreateContainerRegistryConnectionMutationVariables>(CreateContainerRegistryConnectionDocument, options);
      }
export type CreateContainerRegistryConnectionMutationHookResult = ReturnType<typeof useCreateContainerRegistryConnectionMutation>;
export type CreateContainerRegistryConnectionMutationResult = Apollo.MutationResult<CreateContainerRegistryConnectionMutation>;
export type CreateContainerRegistryConnectionMutationOptions = Apollo.BaseMutationOptions<CreateContainerRegistryConnectionMutation, CreateContainerRegistryConnectionMutationVariables>;
export const UpdateContainerRegistryConnectionDocument = gql`
    mutation UpdateContainerRegistryConnection($input: UpdateContainerRegistryConnectionInput!) {
  updateContainerRegistryConnection(input: $input) {
    clientMutationId
  }
}
    `;
export type UpdateContainerRegistryConnectionMutationFn = Apollo.MutationFunction<UpdateContainerRegistryConnectionMutation, UpdateContainerRegistryConnectionMutationVariables>;

/**
 * __useUpdateContainerRegistryConnectionMutation__
 *
 * To run a mutation, you first call `useUpdateContainerRegistryConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContainerRegistryConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContainerRegistryConnectionMutation, { data, loading, error }] = useUpdateContainerRegistryConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContainerRegistryConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContainerRegistryConnectionMutation, UpdateContainerRegistryConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContainerRegistryConnectionMutation, UpdateContainerRegistryConnectionMutationVariables>(UpdateContainerRegistryConnectionDocument, options);
      }
export type UpdateContainerRegistryConnectionMutationHookResult = ReturnType<typeof useUpdateContainerRegistryConnectionMutation>;
export type UpdateContainerRegistryConnectionMutationResult = Apollo.MutationResult<UpdateContainerRegistryConnectionMutation>;
export type UpdateContainerRegistryConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateContainerRegistryConnectionMutation, UpdateContainerRegistryConnectionMutationVariables>;
export const DeleteContainerRegistryConnectionDocument = gql`
    mutation DeleteContainerRegistryConnection($input: DeleteContainerRegistryConnectionInput!) {
  deleteContainerRegistryConnection(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteContainerRegistryConnectionMutationFn = Apollo.MutationFunction<DeleteContainerRegistryConnectionMutation, DeleteContainerRegistryConnectionMutationVariables>;

/**
 * __useDeleteContainerRegistryConnectionMutation__
 *
 * To run a mutation, you first call `useDeleteContainerRegistryConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContainerRegistryConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContainerRegistryConnectionMutation, { data, loading, error }] = useDeleteContainerRegistryConnectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContainerRegistryConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContainerRegistryConnectionMutation, DeleteContainerRegistryConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContainerRegistryConnectionMutation, DeleteContainerRegistryConnectionMutationVariables>(DeleteContainerRegistryConnectionDocument, options);
      }
export type DeleteContainerRegistryConnectionMutationHookResult = ReturnType<typeof useDeleteContainerRegistryConnectionMutation>;
export type DeleteContainerRegistryConnectionMutationResult = Apollo.MutationResult<DeleteContainerRegistryConnectionMutation>;
export type DeleteContainerRegistryConnectionMutationOptions = Apollo.BaseMutationOptions<DeleteContainerRegistryConnectionMutation, DeleteContainerRegistryConnectionMutationVariables>;
export const ContainerImagesDocument = gql`
    query ContainerImages($id: UUID!) {
  serviceDefinition(id: $id) {
    id
    repositoryTags {
      containerImageVersion
      tag
    }
    serviceDeployments(condition: {active: true}) {
      nodes {
        containerImageVersion
      }
    }
  }
}
    `;

/**
 * __useContainerImagesQuery__
 *
 * To run a query within a React component, call `useContainerImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContainerImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContainerImagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContainerImagesQuery(baseOptions: Apollo.QueryHookOptions<ContainerImagesQuery, ContainerImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContainerImagesQuery, ContainerImagesQueryVariables>(ContainerImagesDocument, options);
      }
export function useContainerImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContainerImagesQuery, ContainerImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContainerImagesQuery, ContainerImagesQueryVariables>(ContainerImagesDocument, options);
        }
export type ContainerImagesQueryHookResult = ReturnType<typeof useContainerImagesQuery>;
export type ContainerImagesLazyQueryHookResult = ReturnType<typeof useContainerImagesLazyQuery>;
export type ContainerImagesQueryResult = Apollo.QueryResult<ContainerImagesQuery, ContainerImagesQueryVariables>;
export const AzureStorageContainerSasTokenParamsDocument = gql`
    query AzureStorageContainerSASTokenParams($input: AzureStorageContainerSASTokenParamsInput!) {
  azureStorageContainerSASTokenParams(input: $input) {
    allowedIPs
    allowedProtocols
    permissions
    validFrom
    validUntil
  }
}
    `;

/**
 * __useAzureStorageContainerSasTokenParamsQuery__
 *
 * To run a query within a React component, call `useAzureStorageContainerSasTokenParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureStorageContainerSasTokenParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureStorageContainerSasTokenParamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAzureStorageContainerSasTokenParamsQuery(baseOptions: Apollo.QueryHookOptions<AzureStorageContainerSasTokenParamsQuery, AzureStorageContainerSasTokenParamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureStorageContainerSasTokenParamsQuery, AzureStorageContainerSasTokenParamsQueryVariables>(AzureStorageContainerSasTokenParamsDocument, options);
      }
export function useAzureStorageContainerSasTokenParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureStorageContainerSasTokenParamsQuery, AzureStorageContainerSasTokenParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureStorageContainerSasTokenParamsQuery, AzureStorageContainerSasTokenParamsQueryVariables>(AzureStorageContainerSasTokenParamsDocument, options);
        }
export type AzureStorageContainerSasTokenParamsQueryHookResult = ReturnType<typeof useAzureStorageContainerSasTokenParamsQuery>;
export type AzureStorageContainerSasTokenParamsLazyQueryHookResult = ReturnType<typeof useAzureStorageContainerSasTokenParamsLazyQuery>;
export type AzureStorageContainerSasTokenParamsQueryResult = Apollo.QueryResult<AzureStorageContainerSasTokenParamsQuery, AzureStorageContainerSasTokenParamsQueryVariables>;
export const GenerateAzureStorageContainerSasTokenDocument = gql`
    mutation GenerateAzureStorageContainerSASToken($input: GenerateAzureStorageContainerSASTokenInput!) {
  generateAzureStorageContainerSASToken(input: $input) {
    sasTokenUri
    sasTokenParams
  }
}
    `;
export type GenerateAzureStorageContainerSasTokenMutationFn = Apollo.MutationFunction<GenerateAzureStorageContainerSasTokenMutation, GenerateAzureStorageContainerSasTokenMutationVariables>;

/**
 * __useGenerateAzureStorageContainerSasTokenMutation__
 *
 * To run a mutation, you first call `useGenerateAzureStorageContainerSasTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateAzureStorageContainerSasTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateAzureStorageContainerSasTokenMutation, { data, loading, error }] = useGenerateAzureStorageContainerSasTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateAzureStorageContainerSasTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateAzureStorageContainerSasTokenMutation, GenerateAzureStorageContainerSasTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateAzureStorageContainerSasTokenMutation, GenerateAzureStorageContainerSasTokenMutationVariables>(GenerateAzureStorageContainerSasTokenDocument, options);
      }
export type GenerateAzureStorageContainerSasTokenMutationHookResult = ReturnType<typeof useGenerateAzureStorageContainerSasTokenMutation>;
export type GenerateAzureStorageContainerSasTokenMutationResult = Apollo.MutationResult<GenerateAzureStorageContainerSasTokenMutation>;
export type GenerateAzureStorageContainerSasTokenMutationOptions = Apollo.BaseMutationOptions<GenerateAzureStorageContainerSasTokenMutation, GenerateAzureStorageContainerSasTokenMutationVariables>;
export const AzureStorageAccountContainersDocument = gql`
    query AzureStorageAccountContainers($input: AzureStorageContainersQueryInput!) {
  azureStorageContainers(input: $input) {
    containers {
      hasPublicReadAccess
      name
      publicUrl
      updatedAt
    }
  }
}
    `;

/**
 * __useAzureStorageAccountContainersQuery__
 *
 * To run a query within a React component, call `useAzureStorageAccountContainersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAzureStorageAccountContainersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAzureStorageAccountContainersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAzureStorageAccountContainersQuery(baseOptions: Apollo.QueryHookOptions<AzureStorageAccountContainersQuery, AzureStorageAccountContainersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AzureStorageAccountContainersQuery, AzureStorageAccountContainersQueryVariables>(AzureStorageAccountContainersDocument, options);
      }
export function useAzureStorageAccountContainersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AzureStorageAccountContainersQuery, AzureStorageAccountContainersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AzureStorageAccountContainersQuery, AzureStorageAccountContainersQueryVariables>(AzureStorageAccountContainersDocument, options);
        }
export type AzureStorageAccountContainersQueryHookResult = ReturnType<typeof useAzureStorageAccountContainersQuery>;
export type AzureStorageAccountContainersLazyQueryHookResult = ReturnType<typeof useAzureStorageAccountContainersLazyQuery>;
export type AzureStorageAccountContainersQueryResult = Apollo.QueryResult<AzureStorageAccountContainersQuery, AzureStorageAccountContainersQueryVariables>;
export const UpdateDeploymentServiceDocument = gql`
    mutation UpdateDeploymentService($input: UpdateServiceDeploymentInput!) {
  updateServiceDeployment(input: $input) {
    clientMutationId
  }
}
    `;
export type UpdateDeploymentServiceMutationFn = Apollo.MutationFunction<UpdateDeploymentServiceMutation, UpdateDeploymentServiceMutationVariables>;

/**
 * __useUpdateDeploymentServiceMutation__
 *
 * To run a mutation, you first call `useUpdateDeploymentServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeploymentServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeploymentServiceMutation, { data, loading, error }] = useUpdateDeploymentServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeploymentServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeploymentServiceMutation, UpdateDeploymentServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeploymentServiceMutation, UpdateDeploymentServiceMutationVariables>(UpdateDeploymentServiceDocument, options);
      }
export type UpdateDeploymentServiceMutationHookResult = ReturnType<typeof useUpdateDeploymentServiceMutation>;
export type UpdateDeploymentServiceMutationResult = Apollo.MutationResult<UpdateDeploymentServiceMutation>;
export type UpdateDeploymentServiceMutationOptions = Apollo.BaseMutationOptions<UpdateDeploymentServiceMutation, UpdateDeploymentServiceMutationVariables>;
export const ServiceDeploymentDetailsDocument = gql`
    query ServiceDeploymentDetails($id: UUID!) {
  serviceDeployment(id: $id) {
    dnsRecords {
      nodes {
        fqdn
        configRefName
      }
    }
    serviceDeploymentManifest {
      id
      name
      createdDate
    }
    serviceDefinition {
      repositoryName
      serviceId
      name
      ownedByAxinom
      servicePiletArtifacts {
        nodes {
          packageVersion
          name
          id
        }
      }
    }
    containerImageVersion
    servicePiletArtifacts
    status
    serviceDefinitionId
    name
    createdDate
    createdUser
    active
    updatedDate
    updatedUser
    tenantId
    id
    errorMessage
  }
}
    `;

/**
 * __useServiceDeploymentDetailsQuery__
 *
 * To run a query within a React component, call `useServiceDeploymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDeploymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDeploymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceDeploymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<ServiceDeploymentDetailsQuery, ServiceDeploymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDeploymentDetailsQuery, ServiceDeploymentDetailsQueryVariables>(ServiceDeploymentDetailsDocument, options);
      }
export function useServiceDeploymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDeploymentDetailsQuery, ServiceDeploymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDeploymentDetailsQuery, ServiceDeploymentDetailsQueryVariables>(ServiceDeploymentDetailsDocument, options);
        }
export type ServiceDeploymentDetailsQueryHookResult = ReturnType<typeof useServiceDeploymentDetailsQuery>;
export type ServiceDeploymentDetailsLazyQueryHookResult = ReturnType<typeof useServiceDeploymentDetailsLazyQuery>;
export type ServiceDeploymentDetailsQueryResult = Apollo.QueryResult<ServiceDeploymentDetailsQuery, ServiceDeploymentDetailsQueryVariables>;
export const CustomizableServiceDeploymentsDocument = gql`
    query CustomizableServiceDeployments($filter: ServiceDeploymentFilter, $condition: ServiceDeploymentCondition, $orderBy: [ServiceDeploymentsOrderBy!], $after: Cursor) {
  filtered: serviceDeployments(
    filter: $filter
    condition: $condition
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      active
      containerImageVersion
      status
      serviceDeploymentManifest {
        name
      }
      servicePiletArtifacts
      createdDate
      updatedDate
      id
      name
      serviceDefinition {
        name
        id
        repositoryName
      }
      serviceDefinitionId
    }
    totalCount
  }
  nonFiltered: serviceDeployments(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useCustomizableServiceDeploymentsQuery__
 *
 * To run a query within a React component, call `useCustomizableServiceDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomizableServiceDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomizableServiceDeploymentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      condition: // value for 'condition'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCustomizableServiceDeploymentsQuery(baseOptions?: Apollo.QueryHookOptions<CustomizableServiceDeploymentsQuery, CustomizableServiceDeploymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomizableServiceDeploymentsQuery, CustomizableServiceDeploymentsQueryVariables>(CustomizableServiceDeploymentsDocument, options);
      }
export function useCustomizableServiceDeploymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomizableServiceDeploymentsQuery, CustomizableServiceDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomizableServiceDeploymentsQuery, CustomizableServiceDeploymentsQueryVariables>(CustomizableServiceDeploymentsDocument, options);
        }
export type CustomizableServiceDeploymentsQueryHookResult = ReturnType<typeof useCustomizableServiceDeploymentsQuery>;
export type CustomizableServiceDeploymentsLazyQueryHookResult = ReturnType<typeof useCustomizableServiceDeploymentsLazyQuery>;
export type CustomizableServiceDeploymentsQueryResult = Apollo.QueryResult<CustomizableServiceDeploymentsQuery, CustomizableServiceDeploymentsQueryVariables>;
export const CreateServiceDeploymentDocument = gql`
    mutation CreateServiceDeployment($input: InitiateServiceDeploymentInput!) {
  initiateServiceDeployment(input: $input) {
    serviceDefinitionId
    serviceDeploymentId
    status
    name
  }
}
    `;
export type CreateServiceDeploymentMutationFn = Apollo.MutationFunction<CreateServiceDeploymentMutation, CreateServiceDeploymentMutationVariables>;

/**
 * __useCreateServiceDeploymentMutation__
 *
 * To run a mutation, you first call `useCreateServiceDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceDeploymentMutation, { data, loading, error }] = useCreateServiceDeploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceDeploymentMutation, CreateServiceDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceDeploymentMutation, CreateServiceDeploymentMutationVariables>(CreateServiceDeploymentDocument, options);
      }
export type CreateServiceDeploymentMutationHookResult = ReturnType<typeof useCreateServiceDeploymentMutation>;
export type CreateServiceDeploymentMutationResult = Apollo.MutationResult<CreateServiceDeploymentMutation>;
export type CreateServiceDeploymentMutationOptions = Apollo.BaseMutationOptions<CreateServiceDeploymentMutation, CreateServiceDeploymentMutationVariables>;
export const UnDeploymentServiceDocument = gql`
    mutation UnDeploymentService($input: InitiateServiceUndeploymentInput!) {
  initiateServiceUndeployment(input: $input) {
    serviceDefinitionId
    serviceDeploymentId
    status
  }
}
    `;
export type UnDeploymentServiceMutationFn = Apollo.MutationFunction<UnDeploymentServiceMutation, UnDeploymentServiceMutationVariables>;

/**
 * __useUnDeploymentServiceMutation__
 *
 * To run a mutation, you first call `useUnDeploymentServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnDeploymentServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unDeploymentServiceMutation, { data, loading, error }] = useUnDeploymentServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnDeploymentServiceMutation(baseOptions?: Apollo.MutationHookOptions<UnDeploymentServiceMutation, UnDeploymentServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnDeploymentServiceMutation, UnDeploymentServiceMutationVariables>(UnDeploymentServiceDocument, options);
      }
export type UnDeploymentServiceMutationHookResult = ReturnType<typeof useUnDeploymentServiceMutation>;
export type UnDeploymentServiceMutationResult = Apollo.MutationResult<UnDeploymentServiceMutation>;
export type UnDeploymentServiceMutationOptions = Apollo.BaseMutationOptions<UnDeploymentServiceMutation, UnDeploymentServiceMutationVariables>;
export const ReDeploymentServiceDocument = gql`
    mutation ReDeploymentService($input: InitiateServiceRedeploymentInput!) {
  initiateServiceRedeployment(input: $input) {
    serviceDefinitionId
    serviceDeploymentId
    status
  }
}
    `;
export type ReDeploymentServiceMutationFn = Apollo.MutationFunction<ReDeploymentServiceMutation, ReDeploymentServiceMutationVariables>;

/**
 * __useReDeploymentServiceMutation__
 *
 * To run a mutation, you first call `useReDeploymentServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReDeploymentServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reDeploymentServiceMutation, { data, loading, error }] = useReDeploymentServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReDeploymentServiceMutation(baseOptions?: Apollo.MutationHookOptions<ReDeploymentServiceMutation, ReDeploymentServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReDeploymentServiceMutation, ReDeploymentServiceMutationVariables>(ReDeploymentServiceDocument, options);
      }
export type ReDeploymentServiceMutationHookResult = ReturnType<typeof useReDeploymentServiceMutation>;
export type ReDeploymentServiceMutationResult = Apollo.MutationResult<ReDeploymentServiceMutation>;
export type ReDeploymentServiceMutationOptions = Apollo.BaseMutationOptions<ReDeploymentServiceMutation, ReDeploymentServiceMutationVariables>;
export const ServicePiletArtifactsDocument = gql`
    query ServicePiletArtifacts($condition: ServicePiletArtifactCondition, $filter: ServicePiletArtifactFilter, $orderBy: [ServicePiletArtifactsOrderBy!], $after: Cursor) {
  filtered: servicePiletArtifacts(
    condition: $condition
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    nodes {
      id
      name
      packageVersion
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  nonFiltered: servicePiletArtifacts(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useServicePiletArtifactsQuery__
 *
 * To run a query within a React component, call `useServicePiletArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePiletArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePiletArtifactsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useServicePiletArtifactsQuery(baseOptions?: Apollo.QueryHookOptions<ServicePiletArtifactsQuery, ServicePiletArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicePiletArtifactsQuery, ServicePiletArtifactsQueryVariables>(ServicePiletArtifactsDocument, options);
      }
export function useServicePiletArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicePiletArtifactsQuery, ServicePiletArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicePiletArtifactsQuery, ServicePiletArtifactsQueryVariables>(ServicePiletArtifactsDocument, options);
        }
export type ServicePiletArtifactsQueryHookResult = ReturnType<typeof useServicePiletArtifactsQuery>;
export type ServicePiletArtifactsLazyQueryHookResult = ReturnType<typeof useServicePiletArtifactsLazyQuery>;
export type ServicePiletArtifactsQueryResult = Apollo.QueryResult<ServicePiletArtifactsQuery, ServicePiletArtifactsQueryVariables>;
export const ServiceDeploymentManifestsDocument = gql`
    query ServiceDeploymentManifests($condition: ServiceDeploymentManifestCondition, $filter: ServiceDeploymentManifestFilter, $orderBy: [ServiceDeploymentManifestsOrderBy!], $after: Cursor) {
  filtered: serviceDeploymentManifests(
    condition: $condition
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    nodes {
      id
      createdDate
      name
      currentlyInUse
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  nonFiltered: serviceDeploymentManifests(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useServiceDeploymentManifestsQuery__
 *
 * To run a query within a React component, call `useServiceDeploymentManifestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDeploymentManifestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDeploymentManifestsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useServiceDeploymentManifestsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceDeploymentManifestsQuery, ServiceDeploymentManifestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDeploymentManifestsQuery, ServiceDeploymentManifestsQueryVariables>(ServiceDeploymentManifestsDocument, options);
      }
export function useServiceDeploymentManifestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDeploymentManifestsQuery, ServiceDeploymentManifestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDeploymentManifestsQuery, ServiceDeploymentManifestsQueryVariables>(ServiceDeploymentManifestsDocument, options);
        }
export type ServiceDeploymentManifestsQueryHookResult = ReturnType<typeof useServiceDeploymentManifestsQuery>;
export type ServiceDeploymentManifestsLazyQueryHookResult = ReturnType<typeof useServiceDeploymentManifestsLazyQuery>;
export type ServiceDeploymentManifestsQueryResult = Apollo.QueryResult<ServiceDeploymentManifestsQuery, ServiceDeploymentManifestsQueryVariables>;
export const CustomizableServiceDocument = gql`
    query CustomizableService($id: UUID!) {
  serviceDefinition(id: $id) {
    id
    tenantId
    environmentId
    updatedUser
    updatedDate
    createdUser
    createdDate
    name
    repositoryName
    ownedByAxinom
    evaluationPodExpirationDate
    serviceId
    customDnsServiceLabel
    databaseAccessExpiresAt
    serviceDeploymentManifest(orderBy: CREATED_DATE_DESC, first: 1) {
      nodes {
        id
        configMap
        createdDate
        name
      }
    }
    servicePiletArtifacts(orderBy: CREATED_DATE_DESC, first: 1) {
      nodes {
        id
        name
        packageVersion
      }
    }
    serviceDeployments(
      condition: {active: true}
      filter: {status: {notEqualTo: DELETE_COMPLETED}}
    ) {
      nodes {
        name
        servicePiletArtifacts
        id
        status
        errorMessage
        updatedUser
        updatedDate
        createdUser
        createdDate
        serviceDefinition {
          ownedByAxinom
        }
        containerImageVersion
        serviceDeploymentManifest {
          id
          createdDate
          name
        }
        servicePiletArtifactIds
        dnsRecords {
          nodes {
            fqdn
            configRefName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCustomizableServiceQuery__
 *
 * To run a query within a React component, call `useCustomizableServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomizableServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomizableServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomizableServiceQuery(baseOptions: Apollo.QueryHookOptions<CustomizableServiceQuery, CustomizableServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomizableServiceQuery, CustomizableServiceQueryVariables>(CustomizableServiceDocument, options);
      }
export function useCustomizableServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomizableServiceQuery, CustomizableServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomizableServiceQuery, CustomizableServiceQueryVariables>(CustomizableServiceDocument, options);
        }
export type CustomizableServiceQueryHookResult = ReturnType<typeof useCustomizableServiceQuery>;
export type CustomizableServiceLazyQueryHookResult = ReturnType<typeof useCustomizableServiceLazyQuery>;
export type CustomizableServiceQueryResult = Apollo.QueryResult<CustomizableServiceQuery, CustomizableServiceQueryVariables>;
export const RepositoryTagsDocument = gql`
    query RepositoryTags($id: UUID!) {
  serviceDefinition(id: $id) {
    repositoryTags {
      tag
    }
  }
}
    `;

/**
 * __useRepositoryTagsQuery__
 *
 * To run a query within a React component, call `useRepositoryTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepositoryTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepositoryTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRepositoryTagsQuery(baseOptions: Apollo.QueryHookOptions<RepositoryTagsQuery, RepositoryTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RepositoryTagsQuery, RepositoryTagsQueryVariables>(RepositoryTagsDocument, options);
      }
export function useRepositoryTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RepositoryTagsQuery, RepositoryTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RepositoryTagsQuery, RepositoryTagsQueryVariables>(RepositoryTagsDocument, options);
        }
export type RepositoryTagsQueryHookResult = ReturnType<typeof useRepositoryTagsQuery>;
export type RepositoryTagsLazyQueryHookResult = ReturnType<typeof useRepositoryTagsLazyQuery>;
export type RepositoryTagsQueryResult = Apollo.QueryResult<RepositoryTagsQuery, RepositoryTagsQueryVariables>;
export const CustomizableServiceCrumbDataDocument = gql`
    query CustomizableServiceCrumbData($id: UUID!) {
  serviceDefinition(id: $id) {
    name
  }
}
    `;

/**
 * __useCustomizableServiceCrumbDataQuery__
 *
 * To run a query within a React component, call `useCustomizableServiceCrumbDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomizableServiceCrumbDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomizableServiceCrumbDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomizableServiceCrumbDataQuery(baseOptions: Apollo.QueryHookOptions<CustomizableServiceCrumbDataQuery, CustomizableServiceCrumbDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomizableServiceCrumbDataQuery, CustomizableServiceCrumbDataQueryVariables>(CustomizableServiceCrumbDataDocument, options);
      }
export function useCustomizableServiceCrumbDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomizableServiceCrumbDataQuery, CustomizableServiceCrumbDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomizableServiceCrumbDataQuery, CustomizableServiceCrumbDataQueryVariables>(CustomizableServiceCrumbDataDocument, options);
        }
export type CustomizableServiceCrumbDataQueryHookResult = ReturnType<typeof useCustomizableServiceCrumbDataQuery>;
export type CustomizableServiceCrumbDataLazyQueryHookResult = ReturnType<typeof useCustomizableServiceCrumbDataLazyQuery>;
export type CustomizableServiceCrumbDataQueryResult = Apollo.QueryResult<CustomizableServiceCrumbDataQuery, CustomizableServiceCrumbDataQueryVariables>;
export const DeployServiceDocument = gql`
    mutation DeployService($input: InitiateServiceDeploymentInput!) {
  initiateServiceDeployment(input: $input) {
    serviceDefinitionId
  }
}
    `;
export type DeployServiceMutationFn = Apollo.MutationFunction<DeployServiceMutation, DeployServiceMutationVariables>;

/**
 * __useDeployServiceMutation__
 *
 * To run a mutation, you first call `useDeployServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeployServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deployServiceMutation, { data, loading, error }] = useDeployServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeployServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeployServiceMutation, DeployServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeployServiceMutation, DeployServiceMutationVariables>(DeployServiceDocument, options);
      }
export type DeployServiceMutationHookResult = ReturnType<typeof useDeployServiceMutation>;
export type DeployServiceMutationResult = Apollo.MutationResult<DeployServiceMutation>;
export type DeployServiceMutationOptions = Apollo.BaseMutationOptions<DeployServiceMutation, DeployServiceMutationVariables>;
export const UndeployServiceDocument = gql`
    mutation UndeployService($input: InitiateServiceUndeploymentInput!) {
  initiateServiceUndeployment(input: $input) {
    serviceDeploymentId
  }
}
    `;
export type UndeployServiceMutationFn = Apollo.MutationFunction<UndeployServiceMutation, UndeployServiceMutationVariables>;

/**
 * __useUndeployServiceMutation__
 *
 * To run a mutation, you first call `useUndeployServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeployServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeployServiceMutation, { data, loading, error }] = useUndeployServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUndeployServiceMutation(baseOptions?: Apollo.MutationHookOptions<UndeployServiceMutation, UndeployServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndeployServiceMutation, UndeployServiceMutationVariables>(UndeployServiceDocument, options);
      }
export type UndeployServiceMutationHookResult = ReturnType<typeof useUndeployServiceMutation>;
export type UndeployServiceMutationResult = Apollo.MutationResult<UndeployServiceMutation>;
export type UndeployServiceMutationOptions = Apollo.BaseMutationOptions<UndeployServiceMutation, UndeployServiceMutationVariables>;
export const UpdateServiceDefinitionDocument = gql`
    mutation UpdateServiceDefinition($input: UpdateServiceDefinitionInput!) {
  updateServiceDefinition(input: $input) {
    clientMutationId
    serviceDefinition {
      id
      name
      customDnsServiceLabel
    }
  }
}
    `;
export type UpdateServiceDefinitionMutationFn = Apollo.MutationFunction<UpdateServiceDefinitionMutation, UpdateServiceDefinitionMutationVariables>;

/**
 * __useUpdateServiceDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateServiceDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceDefinitionMutation, { data, loading, error }] = useUpdateServiceDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceDefinitionMutation, UpdateServiceDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceDefinitionMutation, UpdateServiceDefinitionMutationVariables>(UpdateServiceDefinitionDocument, options);
      }
export type UpdateServiceDefinitionMutationHookResult = ReturnType<typeof useUpdateServiceDefinitionMutation>;
export type UpdateServiceDefinitionMutationResult = Apollo.MutationResult<UpdateServiceDefinitionMutation>;
export type UpdateServiceDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateServiceDefinitionMutation, UpdateServiceDefinitionMutationVariables>;
export const DeleteServiceDefinitionDocument = gql`
    mutation DeleteServiceDefinition($input: DeleteServiceDefinitionInput!) {
  deleteServiceDefinition(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteServiceDefinitionMutationFn = Apollo.MutationFunction<DeleteServiceDefinitionMutation, DeleteServiceDefinitionMutationVariables>;

/**
 * __useDeleteServiceDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteServiceDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceDefinitionMutation, { data, loading, error }] = useDeleteServiceDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteServiceDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceDefinitionMutation, DeleteServiceDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceDefinitionMutation, DeleteServiceDefinitionMutationVariables>(DeleteServiceDefinitionDocument, options);
      }
export type DeleteServiceDefinitionMutationHookResult = ReturnType<typeof useDeleteServiceDefinitionMutation>;
export type DeleteServiceDefinitionMutationResult = Apollo.MutationResult<DeleteServiceDefinitionMutation>;
export type DeleteServiceDefinitionMutationOptions = Apollo.BaseMutationOptions<DeleteServiceDefinitionMutation, DeleteServiceDefinitionMutationVariables>;
export const SetServiceExpirationDateDocument = gql`
    mutation SetServiceExpirationDate($input: SetServiceExpirationDateInput!) {
  setServiceExpirationDate(input: $input) {
    serviceDefinitionId
    expirationDate
  }
}
    `;
export type SetServiceExpirationDateMutationFn = Apollo.MutationFunction<SetServiceExpirationDateMutation, SetServiceExpirationDateMutationVariables>;

/**
 * __useSetServiceExpirationDateMutation__
 *
 * To run a mutation, you first call `useSetServiceExpirationDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetServiceExpirationDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setServiceExpirationDateMutation, { data, loading, error }] = useSetServiceExpirationDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetServiceExpirationDateMutation(baseOptions?: Apollo.MutationHookOptions<SetServiceExpirationDateMutation, SetServiceExpirationDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetServiceExpirationDateMutation, SetServiceExpirationDateMutationVariables>(SetServiceExpirationDateDocument, options);
      }
export type SetServiceExpirationDateMutationHookResult = ReturnType<typeof useSetServiceExpirationDateMutation>;
export type SetServiceExpirationDateMutationResult = Apollo.MutationResult<SetServiceExpirationDateMutation>;
export type SetServiceExpirationDateMutationOptions = Apollo.BaseMutationOptions<SetServiceExpirationDateMutation, SetServiceExpirationDateMutationVariables>;
export const SetDatabaseAccessDocument = gql`
    mutation SetDatabaseAccess($input: SetDatabaseAccessInput!) {
  setDatabaseAccess(input: $input) {
    serviceDefinitionId
    databaseAccessExpiresAt
  }
}
    `;
export type SetDatabaseAccessMutationFn = Apollo.MutationFunction<SetDatabaseAccessMutation, SetDatabaseAccessMutationVariables>;

/**
 * __useSetDatabaseAccessMutation__
 *
 * To run a mutation, you first call `useSetDatabaseAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDatabaseAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDatabaseAccessMutation, { data, loading, error }] = useSetDatabaseAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDatabaseAccessMutation(baseOptions?: Apollo.MutationHookOptions<SetDatabaseAccessMutation, SetDatabaseAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDatabaseAccessMutation, SetDatabaseAccessMutationVariables>(SetDatabaseAccessDocument, options);
      }
export type SetDatabaseAccessMutationHookResult = ReturnType<typeof useSetDatabaseAccessMutation>;
export type SetDatabaseAccessMutationResult = Apollo.MutationResult<SetDatabaseAccessMutation>;
export type SetDatabaseAccessMutationOptions = Apollo.BaseMutationOptions<SetDatabaseAccessMutation, SetDatabaseAccessMutationVariables>;
export const PiletArtifactsDocument = gql`
    query PiletArtifacts($id: UUID!) {
  serviceDefinition(id: $id) {
    servicePiletArtifacts(orderBy: UPDATED_DATE_DESC) {
      nodes {
        packageVersion
        name
        id
      }
    }
    serviceDeployments(
      filter: {active: {equalTo: true}, status: {notEqualTo: DELETE_COMPLETED}}
    ) {
      nodes {
        servicePiletArtifactIds
      }
    }
  }
}
    `;

/**
 * __usePiletArtifactsQuery__
 *
 * To run a query within a React component, call `usePiletArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePiletArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePiletArtifactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePiletArtifactsQuery(baseOptions: Apollo.QueryHookOptions<PiletArtifactsQuery, PiletArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PiletArtifactsQuery, PiletArtifactsQueryVariables>(PiletArtifactsDocument, options);
      }
export function usePiletArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PiletArtifactsQuery, PiletArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PiletArtifactsQuery, PiletArtifactsQueryVariables>(PiletArtifactsDocument, options);
        }
export type PiletArtifactsQueryHookResult = ReturnType<typeof usePiletArtifactsQuery>;
export type PiletArtifactsLazyQueryHookResult = ReturnType<typeof usePiletArtifactsLazyQuery>;
export type PiletArtifactsQueryResult = Apollo.QueryResult<PiletArtifactsQuery, PiletArtifactsQueryVariables>;
export const CustomizableServicesDocument = gql`
    query CustomizableServices($filter: ServiceDefinitionFilter, $orderBy: [ServiceDefinitionsOrderBy!], $after: Cursor) {
  filtered: serviceDefinitions(
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      serviceId
      name
      ownedByAxinom
      activeDeploymentStatus
      evaluationPodExpirationDate
    }
  }
  nonFiltered: serviceDefinitions {
    totalCount
  }
}
    `;

/**
 * __useCustomizableServicesQuery__
 *
 * To run a query within a React component, call `useCustomizableServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomizableServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomizableServicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCustomizableServicesQuery(baseOptions?: Apollo.QueryHookOptions<CustomizableServicesQuery, CustomizableServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomizableServicesQuery, CustomizableServicesQueryVariables>(CustomizableServicesDocument, options);
      }
export function useCustomizableServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomizableServicesQuery, CustomizableServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomizableServicesQuery, CustomizableServicesQueryVariables>(CustomizableServicesDocument, options);
        }
export type CustomizableServicesQueryHookResult = ReturnType<typeof useCustomizableServicesQuery>;
export type CustomizableServicesLazyQueryHookResult = ReturnType<typeof useCustomizableServicesLazyQuery>;
export type CustomizableServicesQueryResult = Apollo.QueryResult<CustomizableServicesQuery, CustomizableServicesQueryVariables>;
export const CreateServiceDefinitionDocument = gql`
    mutation CreateServiceDefinition($input: CreateServiceDefinitionInput!) {
  createServiceDefinition(input: $input) {
    clientMutationId
    serviceDefinition {
      name
      id
    }
  }
}
    `;
export type CreateServiceDefinitionMutationFn = Apollo.MutationFunction<CreateServiceDefinitionMutation, CreateServiceDefinitionMutationVariables>;

/**
 * __useCreateServiceDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateServiceDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceDefinitionMutation, { data, loading, error }] = useCreateServiceDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceDefinitionMutation, CreateServiceDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceDefinitionMutation, CreateServiceDefinitionMutationVariables>(CreateServiceDefinitionDocument, options);
      }
export type CreateServiceDefinitionMutationHookResult = ReturnType<typeof useCreateServiceDefinitionMutation>;
export type CreateServiceDefinitionMutationResult = Apollo.MutationResult<CreateServiceDefinitionMutation>;
export type CreateServiceDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateServiceDefinitionMutation, CreateServiceDefinitionMutationVariables>;
export const DeploymentManifestDocument = gql`
    query DeploymentManifest($id: UUID!) {
  serviceDeploymentManifest(id: $id) {
    id
    name
    serviceId
    serviceDefinitionId
    ownedByAxinom
    createdDate
    createdUser
    configMap
    tenantId
    environmentId
    serviceDefinition {
      id
      name
    }
  }
}
    `;

/**
 * __useDeploymentManifestQuery__
 *
 * To run a query within a React component, call `useDeploymentManifestQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentManifestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentManifestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeploymentManifestQuery(baseOptions: Apollo.QueryHookOptions<DeploymentManifestQuery, DeploymentManifestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentManifestQuery, DeploymentManifestQueryVariables>(DeploymentManifestDocument, options);
      }
export function useDeploymentManifestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentManifestQuery, DeploymentManifestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentManifestQuery, DeploymentManifestQueryVariables>(DeploymentManifestDocument, options);
        }
export type DeploymentManifestQueryHookResult = ReturnType<typeof useDeploymentManifestQuery>;
export type DeploymentManifestLazyQueryHookResult = ReturnType<typeof useDeploymentManifestLazyQuery>;
export type DeploymentManifestQueryResult = Apollo.QueryResult<DeploymentManifestQuery, DeploymentManifestQueryVariables>;
export const UpdateDeploymentManifestDocument = gql`
    mutation UpdateDeploymentManifest($input: UpdateServiceDeploymentManifestInput!) {
  updateServiceDeploymentManifest(input: $input) {
    clientMutationId
  }
}
    `;
export type UpdateDeploymentManifestMutationFn = Apollo.MutationFunction<UpdateDeploymentManifestMutation, UpdateDeploymentManifestMutationVariables>;

/**
 * __useUpdateDeploymentManifestMutation__
 *
 * To run a mutation, you first call `useUpdateDeploymentManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeploymentManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeploymentManifestMutation, { data, loading, error }] = useUpdateDeploymentManifestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDeploymentManifestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeploymentManifestMutation, UpdateDeploymentManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeploymentManifestMutation, UpdateDeploymentManifestMutationVariables>(UpdateDeploymentManifestDocument, options);
      }
export type UpdateDeploymentManifestMutationHookResult = ReturnType<typeof useUpdateDeploymentManifestMutation>;
export type UpdateDeploymentManifestMutationResult = Apollo.MutationResult<UpdateDeploymentManifestMutation>;
export type UpdateDeploymentManifestMutationOptions = Apollo.BaseMutationOptions<UpdateDeploymentManifestMutation, UpdateDeploymentManifestMutationVariables>;
export const DeploymentManifestsDocument = gql`
    query DeploymentManifests($condition: ServiceDeploymentManifestCondition, $filter: ServiceDeploymentManifestFilter, $orderBy: [ServiceDeploymentManifestsOrderBy!], $after: Cursor) {
  filtered: serviceDeploymentManifests(
    condition: $condition
    filter: $filter
    orderBy: $orderBy
    first: 30
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      name
      createdDate
      currentlyInUse
    }
  }
  nonFiltered: serviceDeploymentManifests(condition: $condition) {
    totalCount
  }
}
    `;

/**
 * __useDeploymentManifestsQuery__
 *
 * To run a query within a React component, call `useDeploymentManifestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeploymentManifestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeploymentManifestsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDeploymentManifestsQuery(baseOptions?: Apollo.QueryHookOptions<DeploymentManifestsQuery, DeploymentManifestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeploymentManifestsQuery, DeploymentManifestsQueryVariables>(DeploymentManifestsDocument, options);
      }
export function useDeploymentManifestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeploymentManifestsQuery, DeploymentManifestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeploymentManifestsQuery, DeploymentManifestsQueryVariables>(DeploymentManifestsDocument, options);
        }
export type DeploymentManifestsQueryHookResult = ReturnType<typeof useDeploymentManifestsQuery>;
export type DeploymentManifestsLazyQueryHookResult = ReturnType<typeof useDeploymentManifestsLazyQuery>;
export type DeploymentManifestsQueryResult = Apollo.QueryResult<DeploymentManifestsQuery, DeploymentManifestsQueryVariables>;
export const DeleteDeploymentManifestDocument = gql`
    mutation DeleteDeploymentManifest($input: DeleteServiceDeploymentManifestInput!) {
  deleteServiceDeploymentManifest(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteDeploymentManifestMutationFn = Apollo.MutationFunction<DeleteDeploymentManifestMutation, DeleteDeploymentManifestMutationVariables>;

/**
 * __useDeleteDeploymentManifestMutation__
 *
 * To run a mutation, you first call `useDeleteDeploymentManifestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeploymentManifestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeploymentManifestMutation, { data, loading, error }] = useDeleteDeploymentManifestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDeploymentManifestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeploymentManifestMutation, DeleteDeploymentManifestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeploymentManifestMutation, DeleteDeploymentManifestMutationVariables>(DeleteDeploymentManifestDocument, options);
      }
export type DeleteDeploymentManifestMutationHookResult = ReturnType<typeof useDeleteDeploymentManifestMutation>;
export type DeleteDeploymentManifestMutationResult = Apollo.MutationResult<DeleteDeploymentManifestMutation>;
export type DeleteDeploymentManifestMutationOptions = Apollo.BaseMutationOptions<DeleteDeploymentManifestMutation, DeleteDeploymentManifestMutationVariables>;
export const HostingServiceConfigurationsDocument = gql`
    query HostingServiceConfigurations {
  serviceConfigurations(first: 1, offset: 0) {
    nodes {
      id
      tenantId
      environmentId
      updatedDate
      updatedUser
    }
  }
}
    `;

/**
 * __useHostingServiceConfigurationsQuery__
 *
 * To run a query within a React component, call `useHostingServiceConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostingServiceConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostingServiceConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHostingServiceConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<HostingServiceConfigurationsQuery, HostingServiceConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostingServiceConfigurationsQuery, HostingServiceConfigurationsQueryVariables>(HostingServiceConfigurationsDocument, options);
      }
export function useHostingServiceConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostingServiceConfigurationsQuery, HostingServiceConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostingServiceConfigurationsQuery, HostingServiceConfigurationsQueryVariables>(HostingServiceConfigurationsDocument, options);
        }
export type HostingServiceConfigurationsQueryHookResult = ReturnType<typeof useHostingServiceConfigurationsQuery>;
export type HostingServiceConfigurationsLazyQueryHookResult = ReturnType<typeof useHostingServiceConfigurationsLazyQuery>;
export type HostingServiceConfigurationsQueryResult = Apollo.QueryResult<HostingServiceConfigurationsQuery, HostingServiceConfigurationsQueryVariables>;
export const HostingServiceStorageDocument = gql`
    query HostingServiceStorage {
  objectStorages(first: 1, offset: 0) {
    nodes {
      id
      title
      tenantId
      environmentId
      provider
      status
      createdDate
      createdUser
      updatedDate
      updatedUser
    }
  }
}
    `;

/**
 * __useHostingServiceStorageQuery__
 *
 * To run a query within a React component, call `useHostingServiceStorageQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostingServiceStorageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostingServiceStorageQuery({
 *   variables: {
 *   },
 * });
 */
export function useHostingServiceStorageQuery(baseOptions?: Apollo.QueryHookOptions<HostingServiceStorageQuery, HostingServiceStorageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostingServiceStorageQuery, HostingServiceStorageQueryVariables>(HostingServiceStorageDocument, options);
      }
export function useHostingServiceStorageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostingServiceStorageQuery, HostingServiceStorageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostingServiceStorageQuery, HostingServiceStorageQueryVariables>(HostingServiceStorageDocument, options);
        }
export type HostingServiceStorageQueryHookResult = ReturnType<typeof useHostingServiceStorageQuery>;
export type HostingServiceStorageLazyQueryHookResult = ReturnType<typeof useHostingServiceStorageLazyQuery>;
export type HostingServiceStorageQueryResult = Apollo.QueryResult<HostingServiceStorageQuery, HostingServiceStorageQueryVariables>;
export const EnableStorageDocument = gql`
    mutation EnableStorage($input: EnableStorageInput!) {
  enableStorage(input: $input) {
    success
  }
}
    `;
export type EnableStorageMutationFn = Apollo.MutationFunction<EnableStorageMutation, EnableStorageMutationVariables>;

/**
 * __useEnableStorageMutation__
 *
 * To run a mutation, you first call `useEnableStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableStorageMutation, { data, loading, error }] = useEnableStorageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableStorageMutation(baseOptions?: Apollo.MutationHookOptions<EnableStorageMutation, EnableStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableStorageMutation, EnableStorageMutationVariables>(EnableStorageDocument, options);
      }
export type EnableStorageMutationHookResult = ReturnType<typeof useEnableStorageMutation>;
export type EnableStorageMutationResult = Apollo.MutationResult<EnableStorageMutation>;
export type EnableStorageMutationOptions = Apollo.BaseMutationOptions<EnableStorageMutation, EnableStorageMutationVariables>;
export const DisableStorageDocument = gql`
    mutation DisableStorage($input: DisableStorageInput!) {
  disableStorage(input: $input) {
    success
  }
}
    `;
export type DisableStorageMutationFn = Apollo.MutationFunction<DisableStorageMutation, DisableStorageMutationVariables>;

/**
 * __useDisableStorageMutation__
 *
 * To run a mutation, you first call `useDisableStorageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableStorageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableStorageMutation, { data, loading, error }] = useDisableStorageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableStorageMutation(baseOptions?: Apollo.MutationHookOptions<DisableStorageMutation, DisableStorageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableStorageMutation, DisableStorageMutationVariables>(DisableStorageDocument, options);
      }
export type DisableStorageMutationHookResult = ReturnType<typeof useDisableStorageMutation>;
export type DisableStorageMutationResult = Apollo.MutationResult<DisableStorageMutation>;
export type DisableStorageMutationOptions = Apollo.BaseMutationOptions<DisableStorageMutation, DisableStorageMutationVariables>;
export const ReadyServiceDeploymentsDocument = gql`
    query ReadyServiceDeployments($filter: ServiceDeploymentFilter) {
  serviceDeployments(filter: $filter) {
    totalCount
  }
}
    `;

/**
 * __useReadyServiceDeploymentsQuery__
 *
 * To run a query within a React component, call `useReadyServiceDeploymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadyServiceDeploymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadyServiceDeploymentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useReadyServiceDeploymentsQuery(baseOptions?: Apollo.QueryHookOptions<ReadyServiceDeploymentsQuery, ReadyServiceDeploymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReadyServiceDeploymentsQuery, ReadyServiceDeploymentsQueryVariables>(ReadyServiceDeploymentsDocument, options);
      }
export function useReadyServiceDeploymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReadyServiceDeploymentsQuery, ReadyServiceDeploymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReadyServiceDeploymentsQuery, ReadyServiceDeploymentsQueryVariables>(ReadyServiceDeploymentsDocument, options);
        }
export type ReadyServiceDeploymentsQueryHookResult = ReturnType<typeof useReadyServiceDeploymentsQuery>;
export type ReadyServiceDeploymentsLazyQueryHookResult = ReturnType<typeof useReadyServiceDeploymentsLazyQuery>;
export type ReadyServiceDeploymentsQueryResult = Apollo.QueryResult<ReadyServiceDeploymentsQuery, ReadyServiceDeploymentsQueryVariables>;
export const RmqConnectionDocument = gql`
    query RMQConnection {
  rmqConnection {
    tenantId
    environmentId
    rmqProtocol
    rmqHost
    rmqPort
    rmqMgmtProtocol
    rmqMgmtHost
    rmqMgmtPort
    rmqVHost
    rmqUser
    rmqPassword
  }
}
    `;

/**
 * __useRmqConnectionQuery__
 *
 * To run a query within a React component, call `useRmqConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRmqConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRmqConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useRmqConnectionQuery(baseOptions?: Apollo.QueryHookOptions<RmqConnectionQuery, RmqConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RmqConnectionQuery, RmqConnectionQueryVariables>(RmqConnectionDocument, options);
      }
export function useRmqConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RmqConnectionQuery, RmqConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RmqConnectionQuery, RmqConnectionQueryVariables>(RmqConnectionDocument, options);
        }
export type RmqConnectionQueryHookResult = ReturnType<typeof useRmqConnectionQuery>;
export type RmqConnectionLazyQueryHookResult = ReturnType<typeof useRmqConnectionLazyQuery>;
export type RmqConnectionQueryResult = Apollo.QueryResult<RmqConnectionQuery, RmqConnectionQueryVariables>;
export const DeleteCredentialsDocument = gql`
    mutation DeleteCredentials {
  deleteRMQUser {
    environmentId
    rmqUser
    rmqVHost
    tenantId
  }
}
    `;
export type DeleteCredentialsMutationFn = Apollo.MutationFunction<DeleteCredentialsMutation, DeleteCredentialsMutationVariables>;

/**
 * __useDeleteCredentialsMutation__
 *
 * To run a mutation, you first call `useDeleteCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCredentialsMutation, { data, loading, error }] = useDeleteCredentialsMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCredentialsMutation, DeleteCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCredentialsMutation, DeleteCredentialsMutationVariables>(DeleteCredentialsDocument, options);
      }
export type DeleteCredentialsMutationHookResult = ReturnType<typeof useDeleteCredentialsMutation>;
export type DeleteCredentialsMutationResult = Apollo.MutationResult<DeleteCredentialsMutation>;
export type DeleteCredentialsMutationOptions = Apollo.BaseMutationOptions<DeleteCredentialsMutation, DeleteCredentialsMutationVariables>;
export const SetupRmqUserDocument = gql`
    mutation SetupRMQUser {
  setupRMQUser {
    tenantId
    environmentId
    rmqProtocol
    rmqHost
    rmqPort
    rmqMgmtProtocol
    rmqMgmtHost
    rmqMgmtPort
    rmqVHost
    rmqUser
    rmqPassword
  }
}
    `;
export type SetupRmqUserMutationFn = Apollo.MutationFunction<SetupRmqUserMutation, SetupRmqUserMutationVariables>;

/**
 * __useSetupRmqUserMutation__
 *
 * To run a mutation, you first call `useSetupRmqUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupRmqUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupRmqUserMutation, { data, loading, error }] = useSetupRmqUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetupRmqUserMutation(baseOptions?: Apollo.MutationHookOptions<SetupRmqUserMutation, SetupRmqUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupRmqUserMutation, SetupRmqUserMutationVariables>(SetupRmqUserDocument, options);
      }
export type SetupRmqUserMutationHookResult = ReturnType<typeof useSetupRmqUserMutation>;
export type SetupRmqUserMutationResult = Apollo.MutationResult<SetupRmqUserMutation>;
export type SetupRmqUserMutationOptions = Apollo.BaseMutationOptions<SetupRmqUserMutation, SetupRmqUserMutationVariables>;
export const ServiceDeploymentLogsDocument = gql`
    query ServiceDeploymentLogs($condition: ServiceDeploymentLogCondition, $orderBy: [ServiceDeploymentLogsOrderBy!]) {
  serviceDeploymentLogs(condition: $condition, orderBy: $orderBy) {
    nodes {
      id
      initiatedBy
      messageType
      message
      serviceDefinitionId
      timestamp
    }
  }
}
    `;

/**
 * __useServiceDeploymentLogsQuery__
 *
 * To run a query within a React component, call `useServiceDeploymentLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceDeploymentLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceDeploymentLogsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useServiceDeploymentLogsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceDeploymentLogsQuery, ServiceDeploymentLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceDeploymentLogsQuery, ServiceDeploymentLogsQueryVariables>(ServiceDeploymentLogsDocument, options);
      }
export function useServiceDeploymentLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceDeploymentLogsQuery, ServiceDeploymentLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceDeploymentLogsQuery, ServiceDeploymentLogsQueryVariables>(ServiceDeploymentLogsDocument, options);
        }
export type ServiceDeploymentLogsQueryHookResult = ReturnType<typeof useServiceDeploymentLogsQuery>;
export type ServiceDeploymentLogsLazyQueryHookResult = ReturnType<typeof useServiceDeploymentLogsLazyQuery>;
export type ServiceDeploymentLogsQueryResult = Apollo.QueryResult<ServiceDeploymentLogsQuery, ServiceDeploymentLogsQueryVariables>;
export const ObjectStorageLogsDocument = gql`
    query ObjectStorageLogs($condition: ObjectStorageLogCondition, $orderBy: [ObjectStorageLogsOrderBy!]) {
  objectStorageLogs(condition: $condition, orderBy: $orderBy) {
    nodes {
      id
      environmentId
      message
      messageType
      tenantId
      timestamp
    }
  }
}
    `;

/**
 * __useObjectStorageLogsQuery__
 *
 * To run a query within a React component, call `useObjectStorageLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectStorageLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectStorageLogsQuery({
 *   variables: {
 *      condition: // value for 'condition'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useObjectStorageLogsQuery(baseOptions?: Apollo.QueryHookOptions<ObjectStorageLogsQuery, ObjectStorageLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ObjectStorageLogsQuery, ObjectStorageLogsQueryVariables>(ObjectStorageLogsDocument, options);
      }
export function useObjectStorageLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ObjectStorageLogsQuery, ObjectStorageLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ObjectStorageLogsQuery, ObjectStorageLogsQueryVariables>(ObjectStorageLogsDocument, options);
        }
export type ObjectStorageLogsQueryHookResult = ReturnType<typeof useObjectStorageLogsQuery>;
export type ObjectStorageLogsLazyQueryHookResult = ReturnType<typeof useObjectStorageLogsLazyQuery>;
export type ObjectStorageLogsQueryResult = Apollo.QueryResult<ObjectStorageLogsQuery, ObjectStorageLogsQueryVariables>;